import React from "react";
import { Card, Select } from "antd";
import { CHART_FILTERS } from "../../../../../constant";
import ApexChart from "react-apexcharts";

function ChartBox({ title, selectedFilter, data = [], config, setFilter }) {
  return (
    <>
      <Card className="chart-box">
        <div className="top-header">
          <h3>{title}</h3>
          <Select
            value={selectedFilter}
            onChange={(val) => setFilter(val)}
            options={CHART_FILTERS}
          />
        </div>
        <ApexChart
          className="chart"
          height={280}
          type="line"
          options={config}
          series={[{ name: title, data: data }]}
        />
      </Card>
    </>
  );
}

export default ChartBox;
